import { memo, useEffect } from 'react';

import { PublicRoutes } from 'routes';
import isEmpty from 'lodash/isEmpty';
// Import Store
import { useAppDispatch, useAppSelector } from 'store';
import { doLogin, selectAuth } from 'store/slices/auth';
// Import Hooks
import useGoToRoute from 'hooks/GoToRoute';
// Import Constants
import { BrowserStorageKeys } from 'constants/browserStorage';

const App = () => {
    const dispatch = useAppDispatch();
    const { isLoggedIn } = useAppSelector(selectAuth);
    const { listen } = useGoToRoute();

    const init = () => {
        const token = localStorage.getItem(BrowserStorageKeys.accessToken);

        if (!isEmpty(token) && !isLoggedIn) {
            localStorage.setItem(BrowserStorageKeys.accessToken, token ?? '');
            dispatch(doLogin(token));
        }

        // the returned unlisten function is the effect cleanup
        return listen();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(init, []);
    return (
        <div className="crm-wrapper">
            <PublicRoutes />
        </div>
    );
};

export default memo(App);
